/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

interface TimeReportCalendarRowGroupProps {}

export const TimeReportCalendarRowGroup: FC<TimeReportCalendarRowGroupProps> = ({ children, ...restProps }) => {
  return (
    <div
      {...restProps}
      role="rowgroup"
      sx={{
        display: "table-row-group",
      }}>
      {children}
    </div>
  );
};
